import { Card, Container, FloraProvider, globalCss } from '@grupoboticario/flora-react'
import { useEffect, useMemo, useState } from 'react'

import useUUID from './hooks/useUUID'
import InvalidUUID from './components/InvalidUUID'
import FormSwitcher from './components/FormSwitcher'
import FormDriver from './components/FormDriver'
import FormDispatcher from './components/FormDispatcher'
import Header from './components/Header'
import Divider from './components/Divider'
import Footer from './components/Footer'
import schemaDriver from './config/schemaDriver'
import schemaDispatcher from './config/schemaDispatcher'
import useParams from './hooks/useParams'
import useVerifySgnatures from './hooks/useVerifySignatures'
import TagManager from 'react-gtm-module'

const globalStyle = globalCss({
  'html body': { background: '#F5F5F5' },
  'html body *': { fontFamily: "'IBM Plex Sans', sans-serif !important" },
  'html, body, body > div:first-child, div#__next, div#__next > div': {
    height: '100%'
  },
  '.statusCapitalized strong': { textTransform: 'capitalize' }
})

function App() {
  globalStyle()
  const uuid = useUUID()
  const { mode, form } = useParams()
  const {
    signatures: { driverSignedAt, dispatcherSignedAt, errorMessage, number }
  } = useVerifySgnatures({ uuid })
  const [formType, setFormType] = useState<string>('dispatcher')
  const [isDriverSubmited, setIsDriverSubmited] = useState<boolean>(false)
  const [isDispatcherSubmited, setIsDispatcherSubmited] = useState<boolean>(false)
  const [codeNumber, setCodeNumber] = useState<string>('')

  const tagManagerArgs = {
    gtmId: 'GTM-M8P758X'
  }

  TagManager.initialize(tagManagerArgs)

  useEffect(() => {
    if (form) setFormType(form)
  }, [form])

  useEffect(() => {
    if (driverSignedAt) setIsDriverSubmited(true)
    if (dispatcherSignedAt) setIsDispatcherSubmited(true)
    setCodeNumber(number)
  }, [driverSignedAt, dispatcherSignedAt, number])

  const hasError = useMemo(() => !!errorMessage, [errorMessage])

  if (!uuid) {
    return <InvalidUUID />
  }

  return (
    <FloraProvider>
      <Container centerContent size="large" css={{ padding: '0 16px' }}>
        <Card css={{ width: '100%', margin: '30px 0', padding: '32px', boxShadow: '0px 4px 20px 0px #0000001F' }}>
          <Header number={codeNumber} />
          <Divider />
          {hasError ? (
            <h3 style={{ fontSize: '1.6rem', marginBottom: '1.8rem' }}>{errorMessage}</h3>
          ) : (
            <>
              {mode !== 'iframe' && <FormSwitcher type={formType} onChangeForm={setFormType} />}
              {formType === 'driver' && (
                <FormDriver
                  uuid={uuid}
                  title="driverSignature"
                  schema={schemaDriver}
                  type="driver"
                  isSubmited={isDriverSubmited}
                  onSetIsSubmited={setIsDriverSubmited}
                />
              )}
              {formType === 'dispatcher' && (
                <FormDispatcher
                  uuid={uuid}
                  title="dispatcherSignature"
                  schema={schemaDispatcher}
                  type="dispatcher"
                  isSubmited={isDispatcherSubmited}
                  onSetIsSubmited={setIsDispatcherSubmited}
                />
              )}
            </>
          )}
        </Card>

        <Footer />
      </Container>
    </FloraProvider>
  )
}

export default App
